import React from 'react';
import {Trans} from 'react-i18next';
import {DASHBO_DOMAIN} from "../../settings/settings";

// Los dos links de antes ("Términos de servicio | Políticas de privacidad") llevaban a la misma página.
const TERMS_URL = `https://${DASHBO_DOMAIN}/terminos-y-privacidad`;

// El texto del link lo pone <Trans> desde la traducción (`<0>…</0>` en `login.terms`).
// eslint-disable-next-line jsx-a11y/anchor-has-content
const termsLink = <a href={TERMS_URL} target="_blank" rel="noopener noreferrer"/>;

export function TermsAndConditions() {
    return (
        <div className="terms-section">
            <p>
                <Trans i18nKey="login.terms" components={[termsLink]}/>
            </p>
        </div>
    );
}
